'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 43h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                d: 'M53.258 27.028V23.78l1.95-2.058h3.899v5.307z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                transform: 'matrix(1 0 0 -1 0 6.75)',
                d: 'M53.258 6.028V2.78l1.95-2.058h3.899v5.307z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                transform: 'rotate(180 3.182 3.375)',
                d: 'M.258 6.028V2.78L2.208.721h3.899v5.307z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                transform: 'matrix(-1 0 0 1 8.365 0)',
                d: 'M1.258 27.028V23.78l1.95-2.058h3.899v5.307z'
            }),
            _react2.default.createElement('circle', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                cx: '30',
                cy: '14',
                r: '8'
            }),
            _react2.default.createElement('path', {
                d: 'M30 7.478c-3.619 0-6.563 2.936-6.563 6.544 0 3.607 2.944 6.543 6.563 6.543 3.619 0 6.563-2.936 6.563-6.543 0-3.608-2.944-6.544-6.563-6.544m0 14.957c-4.652 0-8.438-3.774-8.438-8.413 0-4.64 3.786-8.413 8.438-8.413 4.652 0 8.438 3.773 8.438 8.413 0 4.64-3.786 8.413-8.438 8.413',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M42.188 14.957h1.874v-1.87h-1.874zM45.938 14.957h1.874v-1.87h-1.874zM12.188 14.957h1.874v-1.87h-1.874zM15.938 14.957h1.874v-1.87h-1.875z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M5.076 7.478H.938v-1.87h3.361l1.326-1.321V.935H7.5V5.06zM7.5 27.109H5.625v-3.352l-1.326-1.322H.937v-1.87h4.139L7.5 22.983zM59.063 7.478h-4.139L52.5 5.061V.935h1.875v3.352l1.326 1.322h3.361zM54.375 27.109H52.5v-4.126l2.424-2.418h4.139v1.87H55.7l-1.326 1.322zM29.063 16.826h1.875v-5.609h-1.875zM60 43H0v-1.87h58.125v-1.87H0v-1.869h60z'
            }),
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                mask: 'url(#b)',
                d: 'M0 35.522h60v-1.87H0z'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M0 31.783h60v-1.87H0z'
            }),
            _react2.default.createElement('path', {
                d: 'M1.875 26.174h56.25V1.87H1.875v24.304zM0 28.044h60V0H0v28.043z',
                fill: '#3F5060',
                mask: 'url(#b)'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '43',
    viewBox: '0 0 60 43',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;